// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"ddec3e6b","892":"2f4cacc7","944":"ddec3e6b"}[chunkId] + ".chunk.css";
};